// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file call/call_model.proto.
 */
export const file_call_call_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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'
  );

/**
 * @generated from message com.gem.bff.contract.Call
 */
export type Call = Message<'com.gem.bff.contract.Call'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: com.gem.bff.contract.Call.Status status = 3;
   */
  status: Call_Status;

  /**
   * @generated from field: com.gem.bff.contract.CallSettings settings = 5;
   */
  settings?: CallSettings;

  /**
   * @generated from field: optional string actualRecordingId = 6;
   */
  actualRecordingId?: string;

  /**
   * @generated from field: optional string callName = 7;
   */
  callName?: string;

  /**
   * @generated from field: int64 approxDurationMs = 8;
   */
  approxDurationMs: bigint;
};

/**
 * Describes the message com.gem.bff.contract.Call.
 * Use `create(CallSchema)` to create a new message.
 */
export const CallSchema: GenMessage<Call> = /*@__PURE__*/ messageDesc(file_call_call_model, 0);

/**
 * @generated from enum com.gem.bff.contract.Call.Status
 */
export enum Call_Status {
  /**
   * @generated from enum value: IN_PROGRESS = 0;
   */
  IN_PROGRESS = 0,

  /**
   * @generated from enum value: DECLINED = 1;
   */
  DECLINED = 1,

  /**
   * @generated from enum value: UNANSWERED = 2;
   */
  UNANSWERED = 2,

  /**
   * @generated from enum value: FINISHED = 3;
   */
  FINISHED = 3,
}

/**
 * Describes the enum com.gem.bff.contract.Call.Status.
 */
export const Call_StatusSchema: GenEnum<Call_Status> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 0, 0);

/**
 * @generated from enum com.gem.bff.contract.Call.FinishReason
 */
export enum Call_FinishReason {
  /**
   * @generated from enum value: DURATION_LIMIT_REACHED = 0;
   */
  DURATION_LIMIT_REACHED = 0,
}

/**
 * Describes the enum com.gem.bff.contract.Call.FinishReason.
 */
export const Call_FinishReasonSchema: GenEnum<Call_FinishReason> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 0, 1);

/**
 * @generated from message com.gem.bff.contract.CallMember
 */
export type CallMember = Message<'com.gem.bff.contract.CallMember'> & {
  /**
   * @generated from field: int64 memberId = 1;
   */
  memberId: bigint;

  /**
   * @generated from field: com.gem.bff.contract.CallMember.DisplayData displayData = 7;
   */
  displayData?: CallMember_DisplayData;

  /**
   * @generated from field: com.gem.bff.contract.CallMemberDevice device = 4;
   */
  device?: CallMemberDevice;

  /**
   * @generated from field: com.gem.bff.contract.CallMember.Status status = 5;
   */
  status: CallMember_Status;

  /**
   * @generated from field: bool isAdmin = 6;
   */
  isAdmin: boolean;
};

/**
 * Describes the message com.gem.bff.contract.CallMember.
 * Use `create(CallMemberSchema)` to create a new message.
 */
export const CallMemberSchema: GenMessage<CallMember> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 1);

/**
 * @generated from message com.gem.bff.contract.CallMember.DisplayData
 */
export type CallMember_DisplayData = Message<'com.gem.bff.contract.CallMember.DisplayData'> & {
  /**
   * @generated from field: string userName = 1;
   */
  userName: string;

  /**
   * @generated from field: optional string avatarUrl = 2;
   */
  avatarUrl?: string;
};

/**
 * Describes the message com.gem.bff.contract.CallMember.DisplayData.
 * Use `create(CallMember_DisplayDataSchema)` to create a new message.
 */
export const CallMember_DisplayDataSchema: GenMessage<CallMember_DisplayData> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 1, 0);

/**
 * @generated from enum com.gem.bff.contract.CallMember.Status
 */
export enum CallMember_Status {
  /**
   * @generated from enum value: INITIATED = 0;
   */
  INITIATED = 0,

  /**
   * @generated from enum value: JOINED = 1;
   */
  JOINED = 1,

  /**
   * @generated from enum value: DECLINED = 2;
   */
  DECLINED = 2,

  /**
   * @generated from enum value: LEFT = 3;
   */
  LEFT = 3,
}

/**
 * Describes the enum com.gem.bff.contract.CallMember.Status.
 */
export const CallMember_StatusSchema: GenEnum<CallMember_Status> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 1, 0);

/**
 * @generated from enum com.gem.bff.contract.CallMember.Role
 */
export enum CallMember_Role {
  /**
   * @generated from enum value: SUPERUSER = 0;
   */
  SUPERUSER = 0,

  /**
   * @generated from enum value: MEMBER = 1;
   */
  MEMBER = 1,

  /**
   * @generated from enum value: GUEST = 2;
   */
  GUEST = 2,
}

/**
 * Describes the enum com.gem.bff.contract.CallMember.Role.
 */
export const CallMember_RoleSchema: GenEnum<CallMember_Role> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 1, 1);

/**
 * @generated from message com.gem.bff.contract.ParticipantIdToRole
 */
export type ParticipantIdToRole = Message<'com.gem.bff.contract.ParticipantIdToRole'> & {
  /**
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * @generated from field: com.gem.bff.contract.CallMember.Role role = 2;
   */
  role: CallMember_Role;
};

/**
 * Describes the message com.gem.bff.contract.ParticipantIdToRole.
 * Use `create(ParticipantIdToRoleSchema)` to create a new message.
 */
export const ParticipantIdToRoleSchema: GenMessage<ParticipantIdToRole> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 2);

/**
 * @generated from message com.gem.bff.contract.CallMemberSelfData
 */
export type CallMemberSelfData = Message<'com.gem.bff.contract.CallMemberSelfData'> & {
  /**
   * @generated from field: com.gem.bff.contract.CallMember member = 1;
   */
  member?: CallMember;

  /**
   * @generated from field: string cameraToken = 2;
   */
  cameraToken: string;

  /**
   * @generated from field: string screenToken = 3;
   */
  screenToken: string;

  /**
   * @generated from field: com.gem.bff.contract.CallMemberPermissions permissions = 4;
   */
  permissions?: CallMemberPermissions;

  /**
   * @generated from field: com.gem.bff.contract.CallUiConfiguration callUiConfiguration = 5;
   */
  callUiConfiguration?: CallUiConfiguration;
};

/**
 * Describes the message com.gem.bff.contract.CallMemberSelfData.
 * Use `create(CallMemberSelfDataSchema)` to create a new message.
 */
export const CallMemberSelfDataSchema: GenMessage<CallMemberSelfData> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 3);

/**
 * @generated from message com.gem.bff.contract.CallMemberPermissions
 */
export type CallMemberPermissions = Message<'com.gem.bff.contract.CallMemberPermissions'> & {
  /**
   * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions personalized = 1;
   */
  personalized?: PersonalizedCallPermissions;

  /**
   * @generated from field: com.gem.bff.contract.CallPermissions default = 2;
   */
  default?: CallPermissions;

  /**
   * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions defaultPersonalized = 3;
   */
  defaultPersonalized?: PersonalizedCallPermissions;
};

/**
 * Describes the message com.gem.bff.contract.CallMemberPermissions.
 * Use `create(CallMemberPermissionsSchema)` to create a new message.
 */
export const CallMemberPermissionsSchema: GenMessage<CallMemberPermissions> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 4);

/**
 * @generated from message com.gem.bff.contract.CallInfo
 */
export type CallInfo = Message<'com.gem.bff.contract.CallInfo'> & {
  /**
   * @generated from field: com.gem.bff.contract.Call call = 1;
   */
  call?: Call;

  /**
   * @generated from field: com.gem.bff.contract.CallMember initiatorData = 2 [deprecated = true];
   * @deprecated
   */
  initiatorData?: CallMember;

  /**
   * @generated from field: int64 initiatorId = 4;
   */
  initiatorId: bigint;

  /**
   * @generated from field: com.gem.bff.contract.CallMemberSelfData selfData = 3;
   */
  selfData?: CallMemberSelfData;
};

/**
 * Describes the message com.gem.bff.contract.CallInfo.
 * Use `create(CallInfoSchema)` to create a new message.
 */
export const CallInfoSchema: GenMessage<CallInfo> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 5);

/**
 * @generated from message com.gem.bff.contract.CallSettings
 */
export type CallSettings = Message<'com.gem.bff.contract.CallSettings'> & {
  /**
   * @generated from field: int32 maxBroadcasters = 1;
   */
  maxBroadcasters: number;

  /**
   * @generated from field: int32 callVisibleDurationMs = 2;
   */
  callVisibleDurationMs: number;

  /**
   * @generated from field: bool waitingRoomEnabled = 3;
   */
  waitingRoomEnabled: boolean;

  /**
   * @generated from field: bool guestsAllowed = 4;
   */
  guestsAllowed: boolean;

  /**
   * @generated from field: com.gem.bff.contract.VideoQualitySettings videoQualitySettings = 5;
   */
  videoQualitySettings?: VideoQualitySettings;

  /**
   * @generated from field: int32 maxParticipants = 6;
   */
  maxParticipants: number;

  /**
   * @generated from field: optional int32 maxParticipantsReminder = 7;
   */
  maxParticipantsReminder?: number;

  /**
   * @generated from field: optional int64 maxDurationMs = 8;
   */
  maxDurationMs?: bigint;

  /**
   * @generated from field: optional int64 maxDurationReminderMs = 9;
   */
  maxDurationReminderMs?: bigint;
};

/**
 * Describes the message com.gem.bff.contract.CallSettings.
 * Use `create(CallSettingsSchema)` to create a new message.
 */
export const CallSettingsSchema: GenMessage<CallSettings> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 6);

/**
 * @generated from message com.gem.bff.contract.VideoQualitySettings
 */
export type VideoQualitySettings = Message<'com.gem.bff.contract.VideoQualitySettings'> & {
  /**
   * @generated from field: com.gem.bff.contract.VideoQualityPreset low = 1;
   */
  low?: VideoQualityPreset;

  /**
   * @generated from field: com.gem.bff.contract.VideoQualityPreset medium = 2;
   */
  medium?: VideoQualityPreset;

  /**
   * @generated from field: com.gem.bff.contract.VideoQualityPreset high = 3;
   */
  high?: VideoQualityPreset;
};

/**
 * Describes the message com.gem.bff.contract.VideoQualitySettings.
 * Use `create(VideoQualitySettingsSchema)` to create a new message.
 */
export const VideoQualitySettingsSchema: GenMessage<VideoQualitySettings> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 7);

/**
 * @generated from message com.gem.bff.contract.VideoQualityPreset
 */
export type VideoQualityPreset = Message<'com.gem.bff.contract.VideoQualityPreset'> & {
  /**
   * @generated from field: com.gem.bff.contract.VideoResolution resolution = 1;
   */
  resolution: VideoResolution;

  /**
   * @generated from field: int32 maxBitrate = 2;
   */
  maxBitrate: number;

  /**
   * @generated from field: int32 maxFps = 3;
   */
  maxFps: number;
};

/**
 * Describes the message com.gem.bff.contract.VideoQualityPreset.
 * Use `create(VideoQualityPresetSchema)` to create a new message.
 */
export const VideoQualityPresetSchema: GenMessage<VideoQualityPreset> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 8);

/**
 * @generated from message com.gem.bff.contract.CallMemberDevice
 */
export type CallMemberDevice = Message<'com.gem.bff.contract.CallMemberDevice'> & {
  /**
   * @generated from field: string cameraId = 1;
   */
  cameraId: string;

  /**
   * @generated from field: string screenId = 2;
   */
  screenId: string;

  /**
   * @generated from field: optional string deviceId = 3;
   */
  deviceId?: string;
};

/**
 * Describes the message com.gem.bff.contract.CallMemberDevice.
 * Use `create(CallMemberDeviceSchema)` to create a new message.
 */
export const CallMemberDeviceSchema: GenMessage<CallMemberDevice> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 9);

/**
 * @generated from message com.gem.bff.contract.CallRecording
 */
export type CallRecording = Message<'com.gem.bff.contract.CallRecording'> & {};

/**
 * Describes the message com.gem.bff.contract.CallRecording.
 * Use `create(CallRecordingSchema)` to create a new message.
 */
export const CallRecordingSchema: GenMessage<CallRecording> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 10);

/**
 * @generated from enum com.gem.bff.contract.CallRecording.Type
 */
export enum CallRecording_Type {
  /**
   * @generated from enum value: AUDIO = 0;
   */
  AUDIO = 0,

  /**
   * @generated from enum value: AUDIO_VIDEO = 1;
   */
  AUDIO_VIDEO = 1,
}

/**
 * Describes the enum com.gem.bff.contract.CallRecording.Type.
 */
export const CallRecording_TypeSchema: GenEnum<CallRecording_Type> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 10, 0);

/**
 * @generated from message com.gem.bff.contract.CallPermissions
 */
export type CallPermissions = Message<'com.gem.bff.contract.CallPermissions'> & {
  /**
   * @generated from field: com.gem.bff.contract.CallPermissions.Level switchOnCamera = 1;
   */
  switchOnCamera: CallPermissions_Level;

  /**
   * @generated from field: com.gem.bff.contract.CallPermissions.Level switchOnMic = 2;
   */
  switchOnMic: CallPermissions_Level;

  /**
   * @generated from field: com.gem.bff.contract.CallPermissions.Level shareScreen = 3;
   */
  shareScreen: CallPermissions_Level;
};

/**
 * Describes the message com.gem.bff.contract.CallPermissions.
 * Use `create(CallPermissionsSchema)` to create a new message.
 */
export const CallPermissionsSchema: GenMessage<CallPermissions> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 11);

/**
 * @generated from enum com.gem.bff.contract.CallPermissions.Level
 */
export enum CallPermissions_Level {
  /**
   * @generated from enum value: EVERYONE = 0;
   */
  EVERYONE = 0,

  /**
   * @generated from enum value: AFTER_APPROVE = 1;
   */
  AFTER_APPROVE = 1,

  /**
   * @generated from enum value: ADMINS_AND_OWNER = 2;
   */
  ADMINS_AND_OWNER = 2,
}

/**
 * Describes the enum com.gem.bff.contract.CallPermissions.Level.
 */
export const CallPermissions_LevelSchema: GenEnum<CallPermissions_Level> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 11, 0);

/**
 * @generated from message com.gem.bff.contract.PersonalizedCallPermissions
 */
export type PersonalizedCallPermissions =
  Message<'com.gem.bff.contract.PersonalizedCallPermissions'> & {
    /**
     * @generated from field: optional com.gem.bff.contract.PersonalizedCallPermissions.Level switchOnCamera = 1;
     */
    switchOnCamera?: PersonalizedCallPermissions_Level;

    /**
     * @generated from field: optional com.gem.bff.contract.PersonalizedCallPermissions.Level switchOnMic = 2;
     */
    switchOnMic?: PersonalizedCallPermissions_Level;

    /**
     * @generated from field: optional com.gem.bff.contract.PersonalizedCallPermissions.Level shareScreen = 3;
     */
    shareScreen?: PersonalizedCallPermissions_Level;
  };

/**
 * Describes the message com.gem.bff.contract.PersonalizedCallPermissions.
 * Use `create(PersonalizedCallPermissionsSchema)` to create a new message.
 */
export const PersonalizedCallPermissionsSchema: GenMessage<PersonalizedCallPermissions> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 12);

/**
 * @generated from enum com.gem.bff.contract.PersonalizedCallPermissions.Level
 */
export enum PersonalizedCallPermissions_Level {
  /**
   * @generated from enum value: ALWAYS = 0;
   */
  ALWAYS = 0,

  /**
   * @generated from enum value: NEVER = 1;
   */
  NEVER = 1,

  /**
   * @generated from enum value: AFTER_APPROVE = 2;
   */
  AFTER_APPROVE = 2,
}

/**
 * Describes the enum com.gem.bff.contract.PersonalizedCallPermissions.Level.
 */
export const PersonalizedCallPermissions_LevelSchema: GenEnum<PersonalizedCallPermissions_Level> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 12, 0);

/**
 * @generated from message com.gem.bff.contract.MemberWithCustomPermissions
 */
export type MemberWithCustomPermissions =
  Message<'com.gem.bff.contract.MemberWithCustomPermissions'> & {
    /**
     * @generated from field: int64 memberId = 1;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions personalized = 2;
     */
    personalized?: PersonalizedCallPermissions;
  };

/**
 * Describes the message com.gem.bff.contract.MemberWithCustomPermissions.
 * Use `create(MemberWithCustomPermissionsSchema)` to create a new message.
 */
export const MemberWithCustomPermissionsSchema: GenMessage<MemberWithCustomPermissions> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 13);

/**
 * @generated from message com.gem.bff.contract.CallPermission
 */
export type CallPermission = Message<'com.gem.bff.contract.CallPermission'> & {};

/**
 * Describes the message com.gem.bff.contract.CallPermission.
 * Use `create(CallPermissionSchema)` to create a new message.
 */
export const CallPermissionSchema: GenMessage<CallPermission> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 14);

/**
 * @generated from enum com.gem.bff.contract.CallPermission.AccessType
 */
export enum CallPermission_AccessType {
  /**
   * @generated from enum value: CAMERA = 0;
   */
  CAMERA = 0,

  /**
   * @generated from enum value: MIC = 1;
   */
  MIC = 1,

  /**
   * @generated from enum value: SCREEN_SHARING = 2;
   */
  SCREEN_SHARING = 2,
}

/**
 * Describes the enum com.gem.bff.contract.CallPermission.AccessType.
 */
export const CallPermission_AccessTypeSchema: GenEnum<CallPermission_AccessType> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 14, 0);

/**
 * @generated from enum com.gem.bff.contract.CallPermission.RequestStatus
 */
export enum CallPermission_RequestStatus {
  /**
   * @generated from enum value: APPROVED = 0;
   */
  APPROVED = 0,

  /**
   * @generated from enum value: DECLINED = 1;
   */
  DECLINED = 1,
}

/**
 * Describes the enum com.gem.bff.contract.CallPermission.RequestStatus.
 */
export const CallPermission_RequestStatusSchema: GenEnum<CallPermission_RequestStatus> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 14, 1);

/**
 * @generated from message com.gem.bff.contract.CallUiConfiguration
 */
export type CallUiConfiguration = Message<'com.gem.bff.contract.CallUiConfiguration'> & {
  /**
   * @generated from field: com.gem.bff.contract.CallUiConfiguration.ParticipantsControlType participantsControlType = 1;
   */
  participantsControlType: CallUiConfiguration_ParticipantsControlType;

  /**
   * @generated from field: bool raiseHandControlEnabled = 2;
   */
  raiseHandControlEnabled: boolean;

  /**
   * @generated from field: bool endCallForAllEnabled = 3;
   */
  endCallForAllEnabled: boolean;

  /**
   * @generated from field: bool permissionsAndAccessControlEnabled = 4;
   */
  permissionsAndAccessControlEnabled: boolean;

  /**
   * @generated from field: bool excludeParticipantsFromUserSearch = 5;
   */
  excludeParticipantsFromUserSearch: boolean;

  /**
   * @generated from field: bool showParticipantsNumberRestrictionBanner = 6;
   */
  showParticipantsNumberRestrictionBanner: boolean;

  /**
   * @generated from field: bool isP2P = 7;
   */
  isP2P: boolean;

  /**
   * @generated from field: bool showAllParticipants = 8;
   */
  showAllParticipants: boolean;

  /**
   * @generated from field: bool accessControlSectionVisible = 9;
   */
  accessControlSectionVisible: boolean;

  /**
   * @generated from field: bool showControlMic = 10;
   */
  showControlMic: boolean;

  /**
   * @generated from field: bool showControlCamera = 11;
   */
  showControlCamera: boolean;

  /**
   * @generated from field: bool showControlScreenSharing = 12;
   */
  showControlScreenSharing: boolean;

  /**
   * @generated from field: bool showControlParticipantListMobile = 13;
   */
  showControlParticipantListMobile: boolean;

  /**
   * @generated from field: bool changeParticipantRole = 14;
   */
  changeParticipantRole: boolean;

  /**
   * @generated from field: com.gem.bff.contract.CallUiConfiguration.ParticipantGridDisplayMode participantGridDisplayMode = 15;
   */
  participantGridDisplayMode: CallUiConfiguration_ParticipantGridDisplayMode;

  /**
   * @generated from field: bool showCopyLinkOnPanel = 16;
   */
  showCopyLinkOnPanel: boolean;

  /**
   * @generated from field: bool showCopyLinkInMoreMenu = 17;
   */
  showCopyLinkInMoreMenu: boolean;

  /**
   * @generated from field: bool showControlBackground = 18;
   */
  showControlBackground: boolean;

  /**
   * @generated from field: bool showControlRecording = 19;
   */
  showControlRecording: boolean;

  /**
   * @generated from field: bool showControlInviteMembers = 20;
   */
  showControlInviteMembers: boolean;

  /**
   * @generated from field: bool isActiveControlParticipantListWeb = 21;
   */
  isActiveControlParticipantListWeb: boolean;

  /**
   * @generated from field: com.gem.bff.contract.CallUiConfiguration.PreviewDisplayMode previewDisplayMode = 22;
   */
  previewDisplayMode: CallUiConfiguration_PreviewDisplayMode;

  /**
   * @generated from field: com.gem.bff.contract.CallUiConfiguration.PermissionsSectionDisplayMode permissionsSectionDisplayMode = 23;
   */
  permissionsSectionDisplayMode: CallUiConfiguration_PermissionsSectionDisplayMode;

  /**
   * @generated from field: com.gem.bff.contract.CallUiConfiguration.MemberListDisplayMode memberListDisplayMode = 24;
   */
  memberListDisplayMode: CallUiConfiguration_MemberListDisplayMode;

  /**
   * @generated from field: bool showCallWillEndSoonBanner = 25;
   */
  showCallWillEndSoonBanner: boolean;

  /**
   * @generated from field: bool showParticipantsLimitWillReachSoonBanner = 26;
   */
  showParticipantsLimitWillReachSoonBanner: boolean;

  /**
   * @generated from field: bool showParticipantsRestrictedLimitReachedBanner = 27;
   */
  showParticipantsRestrictedLimitReachedBanner: boolean;

  /**
   * @generated from field: bool showDurationLimitReachedBanner = 28;
   */
  showDurationLimitReachedBanner: boolean;
};

/**
 * Describes the message com.gem.bff.contract.CallUiConfiguration.
 * Use `create(CallUiConfigurationSchema)` to create a new message.
 */
export const CallUiConfigurationSchema: GenMessage<CallUiConfiguration> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 15);

/**
 * @generated from enum com.gem.bff.contract.CallUiConfiguration.ParticipantGridDisplayMode
 */
export enum CallUiConfiguration_ParticipantGridDisplayMode {
  /**
   * @generated from enum value: ADMIN = 0;
   */
  ADMIN = 0,

  /**
   * @generated from enum value: ALL = 1;
   */
  ALL = 1,
}

/**
 * Describes the enum com.gem.bff.contract.CallUiConfiguration.ParticipantGridDisplayMode.
 */
export const CallUiConfiguration_ParticipantGridDisplayModeSchema: GenEnum<CallUiConfiguration_ParticipantGridDisplayMode> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 15, 0);

/**
 * @generated from enum com.gem.bff.contract.CallUiConfiguration.ParticipantsControlType
 */
export enum CallUiConfiguration_ParticipantsControlType {
  /**
   * @generated from enum value: DISABLED = 0;
   */
  DISABLED = 0,

  /**
   * @generated from enum value: WITH_MAX_NUMBER = 1;
   */
  WITH_MAX_NUMBER = 1,

  /**
   * @generated from enum value: TOTAL_NUMBER = 2;
   */
  TOTAL_NUMBER = 2,
}

/**
 * Describes the enum com.gem.bff.contract.CallUiConfiguration.ParticipantsControlType.
 */
export const CallUiConfiguration_ParticipantsControlTypeSchema: GenEnum<CallUiConfiguration_ParticipantsControlType> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 15, 1);

/**
 * @generated from enum com.gem.bff.contract.CallUiConfiguration.PreviewDisplayMode
 */
export enum CallUiConfiguration_PreviewDisplayMode {
  /**
   * @generated from enum value: DEFAULT_PREVIEW = 0;
   */
  DEFAULT_PREVIEW = 0,

  /**
   * @generated from enum value: WEBINAR_PREVIEW = 1;
   */
  WEBINAR_PREVIEW = 1,
}

/**
 * Describes the enum com.gem.bff.contract.CallUiConfiguration.PreviewDisplayMode.
 */
export const CallUiConfiguration_PreviewDisplayModeSchema: GenEnum<CallUiConfiguration_PreviewDisplayMode> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 15, 2);

/**
 * @generated from enum com.gem.bff.contract.CallUiConfiguration.PermissionsSectionDisplayMode
 */
export enum CallUiConfiguration_PermissionsSectionDisplayMode {
  /**
   * @generated from enum value: CUSTOM_PERMISSIONS = 0;
   */
  CUSTOM_PERMISSIONS = 0,

  /**
   * @generated from enum value: WEBINAR_SPEAKERS = 1;
   */
  WEBINAR_SPEAKERS = 1,
}

/**
 * Describes the enum com.gem.bff.contract.CallUiConfiguration.PermissionsSectionDisplayMode.
 */
export const CallUiConfiguration_PermissionsSectionDisplayModeSchema: GenEnum<CallUiConfiguration_PermissionsSectionDisplayMode> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 15, 3);

/**
 * @generated from enum com.gem.bff.contract.CallUiConfiguration.MemberListDisplayMode
 */
export enum CallUiConfiguration_MemberListDisplayMode {
  /**
   * @generated from enum value: DEFAULT = 0;
   */
  DEFAULT = 0,

  /**
   * @generated from enum value: NAME_WITH_ROLE = 1;
   */
  NAME_WITH_ROLE = 1,
}

/**
 * Describes the enum com.gem.bff.contract.CallUiConfiguration.MemberListDisplayMode.
 */
export const CallUiConfiguration_MemberListDisplayModeSchema: GenEnum<CallUiConfiguration_MemberListDisplayMode> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 15, 4);

/**
 * @generated from enum com.gem.bff.contract.VideoResolution
 */
export enum VideoResolution {
  /**
   * @generated from enum value: P360 = 0;
   */
  P360 = 0,

  /**
   * @generated from enum value: P480 = 1;
   */
  P480 = 1,

  /**
   * @generated from enum value: P720 = 2;
   */
  P720 = 2,

  /**
   * @generated from enum value: P1080 = 3;
   */
  P1080 = 3,
}

/**
 * Describes the enum com.gem.bff.contract.VideoResolution.
 */
export const VideoResolutionSchema: GenEnum<VideoResolution> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 0);
